import './file-input.scss';
import { useState, useCallback } from 'react';
import cn from 'classnames';
import { IconBtn } from '@ru-digital-assets/ui-component';
import { TrashIcon } from 'assets/icons';

interface IFileInput {
  onFileChange: (file?: File) => void;
  label?: string;
}

export default function FileInput({ onFileChange, label }: IFileInput) {
  const [file, setFile] = useState<File>();

  const onFileInputChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.files) {
        const file = event.target.files[0];
        if (file) {
          setFile(file);
          onFileChange(file);
        }
      }
    },
    [onFileChange]
  );

  const onClearFile = useCallback((e) => {
    setFile(undefined);
    onFileChange(undefined);
  }, []);

  return (
    <div
      className={cn('file-input', {
        'file-input_with-file': file,
      })}
    >
      <span
        className={cn('file-input__label', {
          'file-input__label_with-file': file,
        })}
      >
        {label || 'Выберите файл'}
      </span>
      {file && <span className="file-input__file-name">{file.name}</span>}
      <div
        className={cn('file-input__button', {
          'file-input__button_delete': file,
        })}
      >
        {file ? (
          <TrashIcon
            className="cursor-pointer"
            color="#DC2344"
            onClick={onClearFile}
          />
        ) : (
          <IconBtn title="Выбрать файл" outlined sm />
        )}
      </div>
      <input
        type="file"
        className="file-input__field"
        onChange={onFileInputChange}
      />
    </div>
  );
}
